/* Locale configuration for the multilingual storefront.
 * English is the default (served at the root path). Other locales use a path
 * prefix, e.g. /es, /de, /fr, /uk, /ru. `code` values are valid hreflang codes. */
export const LOCALES = [
  { code: "en", name: "English", native: "English", short: "EN" },
  { code: "es", name: "Spanish", native: "Español", short: "ES" },
  { code: "de", name: "German", native: "Deutsch", short: "DE" },
  { code: "fr", name: "French", native: "Français", short: "FR" },
  { code: "uk", name: "Ukrainian", native: "Українська", short: "UK" },
  { code: "ru", name: "Russian", native: "Русский", short: "RU" },
];

export const DEFAULT_LOCALE = "en";
export const LOCALE_CODES = LOCALES.map((l) => l.code);
export const PREFIXED_LOCALES = LOCALE_CODES.filter((c) => c !== DEFAULT_LOCALE);

export const localeMeta = (code) => LOCALES.find((l) => l.code === code) || LOCALES[0];
